
import { CreateElement } from "vue";
import { Component, Mixins } from "vue-property-decorator";

// Import cProd messages
import CProdAutoExpireMsg from "@/components/app/global/contractProducts/cProdAutoExpireMsg.vue";
import CProdCancellationRequest from "@/components/app/global/contractProducts/cProdCancellationRequest.vue";
import CProdMovedMsg from "@/components/app/global/contractProducts/cProdMovedMsg.vue";
import CProdPendingSetupMsg from "@/components/app/global/contractProducts/cProdPendingSetupMsg.vue";
import CProdUnpaidInvoicesMsg from "@/components/app/global/contractProducts/cProdUnpaidInvoicesMsg.vue";
import CProdUnresolvedProvisionRequestsMsg from "@/components/app/global/contractProducts/cProdUnresolvedProvisionRequestsMsg.vue";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

@Component
export default class CProdMessages extends Mixins(CProdInjectorMixin) {
  /**
   * @desc Here we render contract product messages using a render function,
   * otherwise we get unwanted whitespace which breaks the CSS :empty selector
   */

  public render(h: CreateElement) {
    return h("u-messages", {}, [
      h(CProdPendingSetupMsg),
      h(CProdMovedMsg),
      h(CProdCancellationRequest),
      h(CProdUnresolvedProvisionRequestsMsg),
      h(CProdUnpaidInvoicesMsg),
      h(CProdAutoExpireMsg)
    ]);
  }
}
